import React, { createContext, useState, useContext } from 'react';

// Create a context
const HeaderContext = createContext();

// Custom hook to use the HeaderContext
export const useHeader = () => useContext(HeaderContext);


// Create a provider component
export const HeaderProvider = ({ children }) => {
    const [header, setHeader] = useState("Impetus");

    return (
        <HeaderContext.Provider value={{ header, setHeader }}>
            {children}
        </HeaderContext.Provider>
    );
};

